import { render, staticRenderFns } from "./project-download.vue?vue&type=template&id=58d1b5a0&"
import script from "./project-download.vue?vue&type=script&lang=js&"
export * from "./project-download.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports